import React, { useState } from "react";

import AddSocialProfilesModal, {
  SocialProfile,
} from "src/app/modals/AddSocialProfilesModal/AddSocialProfilesModal";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import NotFoundImg from "src/images/empty-state-no-user-found.svg";
import { EmptyTabContainer } from "./EmptyTabContainer/EmptyTabContainer";
import { EmptyTabContent } from "./EmptyTabContent/EmptyTabContent";

interface Props {
  socialProfiles: SocialProfile[];
  taskTitle: string;
  taskId: string;
}

export default function ProfileNotFound(props: Props) {
  const { socialProfiles, taskTitle, taskId } = props;

  const [showAddSocialProfilesModal, setShowAddSocialProfilesModal] =
    useState(false);

  return (
    <EmptyTabContainer className="empty-social-profiles-tab">
      <EmptyTabContent
        header={
          <IDHFormattedMessage
            id="ws_profile_data_for_this_account_was_not_found"
            defaultMessage="Profile data for this account was not found."
          />
        }
        imgUrl={NotFoundImg}
      />

      {showAddSocialProfilesModal && (
        <AddSocialProfilesModal
          objectType="task"
          onClose={() => setShowAddSocialProfilesModal(false)}
          name={taskTitle}
          taskId={taskId}
          socialProfiles={socialProfiles}
        />
      )}
    </EmptyTabContainer>
  );
}
